// Twist around the vertical axis
vec3 displace(vec3 pos, vec2 uv, inout float elevation)
{
    float angle = sin(uTime * uSpeed) * pos.y * uStrength;
    float c = cos(angle);
    float s = sin(angle);
    pos.xz = mat2(c, -s, s, c) * pos.xz;
    elevation = angle;
    return pos;
}
